export default __webpack_public_path__ + "assets/images/e986e970b493125f349fc279b4b3d57b.svg";